export const AUTH_LOADING = "AUTH_LOADING";
export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_FAILED = "SIGN_IN_FAILED";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const LOG_OUT = "LOG_OUT";
export const RESET_AUTH = "RESET_AUTH";
export const RESET_OTP = "OTP_RESET";
export const RESET_RESEND_OTP = "RESET_RESEND_OTP";

export const TRY_AGAIN = "TRY_AGAIN";

export const DOWNLOAD_ATTACHMENT_Loading = "DOWNLOAD_ATTACHMENT_Loading";
export const DOWNLOAD_ATTACHMENT_Success = "DOWNLOAD_ATTACHMENT_Success";
export const DOWNLOAD_ATTACHMENT_Failed = "DOWNLOAD_ATTACHMENT_Failed";
export const DOWNLOAD_ATTACHMENT_Reset = "DOWNLOAD_ATTACHMENT_Reset";

export const GET_PARTNERS_LOADING = "GET_PARTNERS_LOADING";
export const GET_PARTNERS_SUCCESS = "GET_PARTNERS_SUCCESS";
export const GET_PARTNERS_FAILD = "GET_PARTNERS_FAILD";

export const CREATE_MERCHANT_LOADING = "CREATE_MERCHANT_LOADING";
export const CREATE_MERCHANT_SUCCESS = "CREATE_MERCHANT_SUCCESS";
export const CREATE_MERCHANT_FAILD = "CREATE_MERCHANT_FAILD";
export const REMOVE_CREATE_MERCHANT = "REMOVE_CREATE_MERCHANT";

export const OTP_LOADING = "OTP_LOADING";
export const VERFIY_SUCCESS = "VERFIY_SUCCESS";
export const VERFIY_FAILD = "VERFIY_FAILD";

export const RESEND_LOADING = "RESEND_LOADING";
export const RESEND_SUCCESS = "RESEND_SUCCESS";
export const RESEND_FAILD = "RESEND_FAILD";

export const GET_MERCHANTS_SUCCESS = "GET_MERCHANTS_SUCCESS";
export const GET_MERCHANTS_FAILD = "GET_MERCHANTS_FAILD";
export const GET_MERCHANTS_LOADING = "GET_MERCHANTS_LOADING";
export const RESET_MERCHANT_LIST = "RESET_MERCHANT_LIST;";

export const GET_MERCHANTS_RECURRING_SUCCESS =
  "GET_MERCHANTS_RECURRING_SUCCESS";
export const GET_MERCHANTS_RECURRING_FAILD = "GET_MERCHANTS_RECURRING_FAILD";
export const GET_MERCHANTS_RECURRING_LOADING =
  "GET_MERCHANTS_RECURRING_LOADING";
export const RESET_MERCHANT_RECURRING_LIST = "RESET_MERCHANT_RECURRING_LIST;";
export const APPEND_MERCHANTS_RECURRING_SUCCESS =
  "APPEND_MERCHANTS_RECURRING_SUCCESS";

export const MERCHANT_DATA_LOADING = "MERCHANT_DATA_LOADING";
export const MERCHANT_DATA_SUCCESS = "MERCHANT_DATA_SUCCESS";
export const MERCHANT_DATA_FAILD = "MERCHANT_DATA_FAILD";
export const MERCHANT_DATA_REMOVE = "MERCHANT_DATA_REMOVE";

export const MERCHANT_SUMMARY_LOADING = "MERCHANT_SUMMARY_LOADING";
export const MERCHANT_SUMMARY_SUCCESS = "MERCHANT_SUMMARY_SUCCESS";
export const MERCHANT_SUMMARY_FAILD = "MERCHANT_SUMMARY_FAILD";

export const RESET_LOADING = "RESET_LOADING";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAILD = "RESET_FAILD";

export const FORGOTPW_LOADING = "FORGOTPW_LOADING";
export const FORGOTPW_SUCCESS = "FORGOTPW_SUCCESS";
export const FORGOTPW_FAILD = "FORGOTPW_FAILD";
export const FORGOTP_REMOVE = "FORGOTP_REMOVE";

export const ACCESSAPI_LOADING = "ACCESSAPI_LOADING";
export const ACCESSAPI_SUCCESS = "ACCESSAPI_SUCCESS";
export const ACCESSAPI_FAILD = "ACCESSAPI_FAILD";
export const ACCESSAPI_REMOVE = "ACCESSAPI_REMOVE";

export const MERCHANT_SECRET_LOADING = "MERCHANT_SECRET_LOADING";
export const MERCHANT_SECRET_SUCCESS = "MERCHANT_SECRET_SUCCESS";
export const MERCHANT_SECRET_FAILD = "MERCHANT_SECRET_FAILD";

export const EDIT_MERCHANT_LOADING = "EDIT_MERCHANT_LOADING";
export const EDIT_MERCHANT_SUCCESS = "EDIT_MERCHANT_SUCCESS";
export const EDIT_MERCHANT_FAILD = "EDIT_MERCHANT_FAILD";
export const REMOVE_EDIT_MERCHANT = "REMOVE_EDIT_MERCHANT";

export const GET_TERMINALS_LOADING = "GET_TERMINALS_LOADING";
export const GET_TERMINALS_SUCCESS = "GET_TERMINALS_SUCCESS";
export const GET_TERMINALS_FAILD = "GET_TERMINALS_FAILD";
export const GET_TERMINALS_REMOVE = "GET_TERMINALS_REMOVE";

export const GET_RECONCILATION_HISTORY_LOADING =
  "GET_RECONCILATION_HISTORY_LOADING";
export const GET_RECONCILATION_HISTORY_SUCCESS =
  "GET_RECONCILATION_HISTORY_SUCCESS";
export const GET_RECONCILATION_HISTORY_FAILED =
  "GET_RECONCILATION_HISTORY_FAILED";

export const ADD_RECONCILE_LOADING = "ADD_RECONCILE_LOADING";
export const ADD_RECONCILE_SUCCESS = "ADD_RECONCILE_SUCCESS";
export const ADD_RECONCILE_FAILED = "ADD_RECONCILE_FAILED";

export const GET_FILTER_RECONCILIATION_LOADING =
  "GET_FILTER_RECONCILIATION_LOADING";
export const GET_FILTER_RECONCILIATION_SUCCESS =
  "GET_FILTER_RECONCILIATION_SUCCESS";
export const GET_FILTER_RECONCILIATION_FAILD =
  "GET_FILTER_RECONCILIATION_FAILD";
export const GET_FILTER_RECONCILIATION_RESET =
  "GET_FILTER_RECONCILIATION_RESET";

export const GET_OUTLETS_LOADING = "GET_OUTLETS_LOADING";
export const GET_OUTLETS_SUCCESS = "GET_OUTLETS_SUCCESS";
export const GET_OUTLETS_FAILD = "GET_OUTLETS_FAILD";

export const GET_TERMINAL_SUMMARY_LOADING = "GET_TERMINAL_SUMMARY_LOADING";
export const GET_TERMINAL_SUMMARY_SUCCESS = "GET_TERMINAL_SUMMARY_SUCCESS";
export const GET_TERMINAL_SUMMARY_FAILD = "GET_TERMINAL_SUMMARY_FAILD";

export const GET_TSN_TRANSACTIONS_LOADING = "GET_TSN_TRANSACTIONS_LOADING";
export const GET_TSN_TRANSACTIONS_SUCCESS = "GET_TSN_TRANSACTIONS_SUCCESS";
export const GET_TSN_TRANSACTIONS_FAILD = "GET_TSN_TRANSACTIONS_FAILD";
export const REMOVE_TSN_TRANSACTION = "REMOVE_TSN_TRANSACTION";

export const EDIT_USER_LOADING = "EDIT_USER_LOADING";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAILD = "EDIT_USER_FAILD";

export const GET_USERS_LOADING = "GET_USERS_LOADING";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILD = "GET_USERS_FAILD";
export const GET_USERS_REMOVE = "GET_USERS_REMOVE";

export const CREATE_USER_LOADING = "CREATE_USER_LOADING";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILD = "CREATE_USER_FAILD";

export const CREATE_OUTLET_LOADING = "CREATE_OUTLET_LOADING";
export const CREATE_OUTLET_SUCCESS = "CREATE_OUTLET_SUCCESS";
export const CREATE_OUTLET_FAILD = "CREATE_OUTLET_FAILD";

export const USER_SUMMARY_LOADING = "USER_SUMMARY_LOADING";
export const USER_SUMMARY_SUCCESS = "USER_SUMMARY_SUCCESS";
export const USER_SUMMARY_FAILD = "USER_SUMMARY_FAILD";

export const GET_USERS_TERMINALS_LOADING = "GET_USERS_TERMINALS_LOADING";
export const GET_USERS_TERMINALS_SUCCESS = "GET_USERS_TERMINALS_SUCCESS";
export const GET_USERS_TERMINALS_FAILD = "GET_USERS_TERMINALS_FAILD";

export const GET_USERS_TRANSACTIONS_LOADING = "GET_USERS_TRANSACTIONS_LOADING";
export const GET_USERS_TRANSACTIONS_SUCCESS = "GET_USERS_TRANSACTIONS_SUCCESS";
export const GET_USERS_TRANSACTIONS_FAILD = "GET_USERS_TRANSACTIONS_FAILD";
export const REMOVE_USERS_TRANSACTIONS = "REMOVE_USERS_TRANSACTIONS";

export const GET_USERS_BY_OUTLET_LOADING = "GET_USERS_BY_OUTLET_LOADING";
export const GET_USERS_BY_OUTLET_SUCCESS = "GET_USERS_BY_OUTLET_SUCCESS";
export const GET_USERS_BY_OUTLET_FAILD = "GET_USERS_BY_OUTLET_FAILD";

export const GET_OUTLET_SUMMARY_LOADING = "GET_OUTLET_SUMMARY_LOADING";
export const GET_OUTLET_SUMMARY_SUCCESS = "GET_OUTLET_SUMMARY_SUCCESS";
export const GET_OUTLET_SUMMARY_FAILD = "GET_OUTLET_SUMMARY_FAILD";

export const GET_OUTLETS_TERMINALS_LOADING = "GET_OUTLETS_TERMINALS_LOADING";
export const GET_OUTLETS_TERMINALS_SUCCESS = "GET_OUTLETS_TERMINALS_SUCCESS";
export const GET_OUTLETS_TERMINALS_FAILD = "GET_OUTLETS_TERMINALS_FAILD";

export const GET_OUTLET_DETAILS_LOADING = "GET_OUTLET_DETAILS_LOADING";
export const GET_OUTLET_DETAILS_SUCCESS = "GET_OUTLET_DETAILS_SUCCESS";
export const GET_OUTLET_DETAILS_FAILD = "GET_OUTLET_DETAILS_FAILD";

export const EDIT_OUTLET_LOADING = "EDIT_OUTLET_LOADING";
export const EDIT_OUTLET_SUCCESS = "EDIT_OUTLET_SUCCESS";
export const EDIT_OUTLET_FAILD = "EDIT_OUTLET_FAILD";

export const GET_CURRENCY_LOADING = "GET_CURRENCY_LOADING";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAILD = "GET_CURRENCY_FAILD";
export const GET_CURRENCY_REMOVE = "GET_CURRENCY_REMOVE";

export const ADD_CURRENCY_LOADING = "ADD_CURRENCY_LOADING";
export const ADD_CURRENCY_SUCCESS = "ADD_CURRENCY_SUCCESS";
export const ADD_CURRENCY_FAILD = "ADD_CURRENCY_FAILD";

export const GET_BusinessCategory_LOADING = "GET_BusinessCategory_LOADING";
export const GET_BusinessCategory_SUCCESS = "GET_BusinessCategory_SUCCESS";
export const GET_BusinessCategory_FAILD = "GET_BusinessCategory_FAILD";
export const GET_BusinessCategory_RESET = "GET_BusinessCategory_RESET";

export const GET_FilterSearch_LOADING = "GET_FilterSearch_LOADING";
export const GET_FilterSearch_SUCCESS = "GET_FilterSearch_SUCCESS";
export const GET_FilterSearch_FAILD = "GET_FilterSearch_FAILD";
export const Remove_FilterSearch = "Remove_FilterSearch";

export const GET_FILTER_TRANSACTION_LOADING = "GET_FILTER_TRANSACTION_LOADING";
export const GET_FILTER_TRANSACTION_SUCCESS = "GET_FILTER_TRANSACTION_SUCCESS";
export const GET_FILTER_TRANSACTION_FAILD = "GET_FILTER_TRANSACTION_FAILD";
export const GET_FILTER_TRANSACTION_RESET = "GET_FILTER_TRANSACTION_RESET";

export const GET_FILTER_RECURRING_PLANS_LOADING =
  "GET_FILTER_RECURRING_PLANS_LOADING";
export const GET_FILTER_RECURRING_PLANS_SUCCESS =
  "GET_FILTER_RECURRING_PLANS_SUCCESS";
export const GET_FILTER_RECURRING_PLANS_FAILD =
  "GET_FILTER_RECURRING_PLANS_FAILD";
export const GET_FILTER_RECURRING_PLANS_RESET =
  "GET_FILTER_RECURRING_PLANS_RESET";

export const GET_CountriesCities_LOADING = "GET_CountriesCities_LOADING";
export const GET_CountriesCities_SUCCESS = "GET_CountriesCities_SUCCESS";
export const GET_CountriesCities_FAILD = "GET_CountriesCities_FAILD";
export const GET_CountriesCities_RESET = "GET_CountriesCities_RESET";

export const Reset_PassWord_Success = "Reset_PassWord_Success";
export const Reset_PassWord_Failed = "Reset_PassWord_Failed";
export const Reset_PassWord_Loading = "Reset_PassWord_Loading";
export const Reset_password_Remove = "Reset_Password_Remove";

export const Add_Terminal_Success = "Add_Terminal_Success";
export const Add_Terminal_Failed = "Add_Terminal_Failed";
export const Add_Terminal_Loading = "Add_Terminal_Loading";
export const Add_Terminal_Reset = "Add_Terminal_Reset";

export const EDIT_Terminal_Success = "EDIT_Terminal_Success";
export const EDIT_Terminal_Failed = "EDIT_Terminal_Failed";
export const EDIT_Terminal_Loading = "EDIT_Terminal_Loading";
export const EDIT_Terminal_Reset = "EDIT_Terminal_Reset";

export const GET_MERCHANT_TRANSACTIONS_SUCCESS = "GET_MERCHANT_TRANSACTIONS";
export const GET_MERCHANT_TRANSACTIONS_FAILED =
  "GET_MERCHANT_TRANSACTIONS_FAILED";
export const GET_MERCHANT_TRANSACTIONS_LOADING =
  "GET_MERCHANT_TRANSACTIONS_LOADING";
export const REMOVE_MERCHANT_TRANSACTIONS = "REMOVE_MERCHANT_TRANSACTIONS";

export const DELETE_TERMINAL_SUCCESS = "DELETE_TERMINAL_SUCCESS";
export const DELETE_TERMINAL_FAILED = "DELETE_TERMINAL_FAILED";
export const DELETE_TERMINAL_LOADING = "DELETE_TERMINAL_LOADING";
export const DELETE_TERMINAL_REMOVE = "DELETE_TERMINAL_REMOVE";

export const GET_TODAY_BALANCE_SUCCESS = "GET_TODAY_BALANCE_SUCCESS";
export const GET_TODAY_BALANCE_FAILED = "GET_TODAY_BALANCE_FAILED";
export const GET_TODAY_BALANCE_LOADING = "GET_TODAY_BALANCE_LOADING";
export const REMOVE_TODAY_BALANCE = "REMOVE_TODAY_BALANCE";

export const GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS =
  "GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS";
export const GET_MERCHANT_TOP_USED_TERMINAL_FAILED =
  "GET_MERCHANT_TOP_USED_TERMINAL_FAILED";
export const GET_MERCHANT_TOP_USED_TERMINAL_LOADING =
  "GET_MERCHANT_TOP_USED_TERMINAL_LOADING";
export const REMOVE_MERCHANT_TOP_USED_TERMINAL =
  "REMOVE_MERCHANT_TOP_USED_TERMINAL";

export const GET_MERCHANT_TRANSACTION_COUNT_SUCCESS =
  "GET_MERCHANT_TRANSACTION_COUNT_SUCCESS";
export const GET_MERCHANT_TRANSACTION_COUNT_FAILED =
  "GET_MERCHANT_TRANSACTION_COUNT_FAILED";
export const GET_MERCHANT_TRANSACTION_COUNT_LOADING =
  "GET_MERCHANT_TRANSACTION_COUNT_LOADING";
export const REMOVE_MERCHANT_TRANSACTION_COUNT =
  "REMOVE_MERCHANT_TRANSACTION_COUNT";

export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_SUCCESS";
export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_FAILED";
export const GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING =
  "GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING";
export const REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES =
  "REMOVE_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES";

export const GET_MERCHANT_USED_SCHEME_SUCCESS =
  "GET_MERCHANT_USED_SCHEME_SUCCESS";
export const GET_MERCHANT_USED_SCHEME_FAILED =
  "GET_MERCHANT_USED_SCHEME_FAILED";
export const GET_MERCHANT_USED_SCHEME_LOADING =
  "GET_MERCHANT_USED_SCHEME_LOADING";
export const REMOVE_MERCHANT_USED_SCHEME = "REMOVE_MERCHANT_USED_SCHEME";

export const GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS =
  "GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS";
export const GET_MERCHANT_TERMINALS_TRANSACTION_FAILED =
  "GET_MERCHANT_TERMINALS_TRANSACTION_FAILED";
export const GET_MERCHANT_TERMINALS_TRANSACTION_LOADING =
  "GET_MERCHANT_TERMINALS_TRANSACTION_LOADING";
export const REMOVE_MERCHANT_TERMINALS_TRANSACTION =
  "REMOVE_MERCHANT_TERMINALS_TRANSACTION";

export const GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS =
  "GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS";
export const GET_MERCHANT_OUTLET_TRANSACTION_FAILED =
  "GET_MERCHANT_OUTLET_TRANSACTION_FAILED";
export const GET_MERCHANT_OUTLET_TRANSACTION_LOADING =
  "GET_MERCHANT_OUTLET_TRANSACTION_LOADING";
export const REMOVE_MERCHANT_OUTLET_TRANSACTION =
  "REMOVE_MERCHANT_OUTLET_TRANSACTION";

export const GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS =
  "GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS";
export const GET_MERCHANT_AVAILABLE_TERMINAL_FAILED =
  "GET_MERCHANT_AVAILABLE_TERMINAL_FAILED";
export const GET_MERCHANT_AVAILABLE_TERMINAL_LOADING =
  "GET_MERCHANT_AVAILABLE_TERMINAL_LOADING";
export const REMOVE_MERCHANT_AVAILABLE_TERMINAL =
  "REMOVE_MERCHANT_AVAILABLE_TERMINAL";

export const EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_SUCCESS";
export const EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_FAILED";
export const EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING =
  "EDIT_MERCHANT_AVAILABLE_TERMINAL_LOADING";

export const ADD_TERMINAL_RETAILER_DATA_SUCCESS =
  "ADD_TERMINAL_RETAILER_DATA_SUCCESS";
export const ADD_TERMINAL_RETAILER_DATA_FAILED =
  "ADD_TERMINAL_RETAILER_DATA_FAILED";
export const ADD_TERMINAL_RETAILER_DATA_LOADING =
  "ADD_TERMINAL_RTAILER_DATA_LOADING";

export const ADD_TERMINAL_TMS_SCHEME_SUCCESS =
  "ADD_TERMINAL_TMS_SCHEME_SUCCESS";
export const ADD_TERMINAL_TMS_SCHEME_FAILED = "ADD_TERMINAL_TMS_SCHEME_FAILED";
export const ADD_TERMINAL_TMS_SCHEME_LOADING =
  "ADD_TERMINAL_TMS_SCHEME_LOADING";

export const ADD_CREATE_INVOICE_SUCCESS = "ADD_CREATE_INVOICE_SUCCESS";
export const ADD_CREATE_INVOICE_FAILED = "ADD_CREATE_INVOICE_FAILED";
export const ADD_CREATE_INVOICE_LOADING = "ADD_CREATE_INVOICE_LOADING";
export const REMOVE_CREATE_INVOICE = "REMOVE_CREATE_INVOICE";

export const GET_MERCHANT_INVOICE_LIST_SUCCESS =
  "GET_MERCHANT_INVOICE_LIST_SUCCESS";
export const GET_MERCHANT_INVOICE_LIST_FAILED =
  "GET_MERCHANT_INVOICE_LIST_FAILED";
export const GET_MERCHANT_INVOICE_LIST_LOADING =
  "GET_MERCHANT_INVOICE_LIST_LOADING";
export const REMOVE_MERCHANT_INVOICE_LIST = "REMOVE_MERCHANT_INVOICE_LIST";

export const GET_RECURRING_PAYMENTS_LIST_SUCCESS =
  "GET_RECURRING_PAYMENTS_LIST_SUCCESS";
export const GET_RECURRING_PAYMENTS_LIST_FAILED =
  "GET_RECURRING_PAYMENTS_LIST_FAILED";
export const GET_RECURRING_PAYMENTS_LIST_LOADING =
  "GET_RECURRING_PAYMENTS_LIST_LOADING";
export const REMOVE_RECURRING_PAYMENTS_LIST = "REMOVE_RECURRING_PAYMENTS_LIST";

export const GET_MERCHANT_INVOICE_SUCCESS = "GET_MERCHANT_INVOICE_SUCCESS";
export const GET_MERCHANT_INVOICE_FAILED = "GET_MERCHANT_INVOICE_FAILED";
export const GET_MERCHANT_INVOICE_LOADING = "GET_MERCHANT_INVOICE_LOADING";
export const REMOVE_MERCHANT_INVOICE = "REMOVE_MERCHANT_INVOICE";

export const GET_FILTER_INVOICES_LOADING = "GET_FILTER_INVOICES_LOADING";
export const GET_FILTER_INVOICES_SUCCESS = "GET_FILTER_INVOICES_SUCCESS";
export const GET_FILTER_INVOICES_FAILD = "GET_FILTER_INVOICES_FAILD";
export const GET_FILTER_INVOICES_RESET = "GET_FILTER_INVOICES_RESET";

export const GET_MERCHANT_PAYMENT_CONFIG_SUCCESS =
  "GET_MERCHANT_PAYMENT_CONFIG_SUCCESS";
export const GET_MERCHANT_PAYMENT_CONFIG_FAILED =
  "GET_MERCHANT_PAYMENT_CONFIG_FAILED";
export const GET_MERCHANT_PAYMENT_CONFIG_LOADING =
  "GET_MERCHANT_PAYMENT_CONFIG_LOADING";
export const REMOVE_MERCHANT_PAYMENT_CONFIG = "REMOVE_MERCHANT_PAYMENT_CONFIG";

export const ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS =
  "ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS";
export const ADD_MERCHANT_PAYMENT_CONFIG_FAILED =
  "ADD_MERCHANT_PAYMENT_CONFIG_FAILED";
export const ADD_MERCHANT_PAYMENT_CONFIG_LOADING =
  "ADD_MERCHANT_PAYMENT_CONFIG_LOADING";
export const REMOVE_ADD_MERCHANT_PAYMENT_CONFIG =
  "REMOVE_ADD_MERCHANT_PAYMENT_CONFIG";

export const GET_INVOICE_PAYMENT_URL_SUCCESS =
  "GET_INVOICE_PAYMENT_URL_SUCCESS";
export const GET_INVOICE_PAYMENT_URL_FAILED = "GET_INVOICE_PAYMENT_URL_FAILED";
export const GET_INVOICE_PAYMENT_URL_LOADING =
  "GET_INVOICE_PAYMENT_URL_LOADING";
export const REMOVE_INVOICE_PAYMENT_URL = "REMOVE_MERCHANT_PAYMENT_URL";

export const EDIT_INVOICE_STATUS_Success = "EDIT_INVOICE_STATUS_Success";
export const EDIT_INVOICE_STATUS_Failed = "EDIT_INVOICE_STATUS_Failed";
export const EDIT_INVOICE_STATUS_Loading = "EDIT_INVOICE_STATUS_Loading";
export const EDIT_INVOICE_STATUS_Reset = "EDIT_INVOICE_STATUS_Reset";

export const DOWNLOAD_INVOICE_Success = "DOWNLOAD_INVOICE_Success";
export const DOWNLOAD_INVOICE_Failed = "DOWNLOAD_INVOICE_Failed";
export const DOWNLOAD_INVOICE_Loading = "DOWNLOAD_INVOICE_Loading";
export const DOWNLOAD_INVOICE_Reset = "DOWNLOAD_INVOICE_Reset";

export const SEND_INVOICE_NOTIIFICATION_Success =
  "SEND_INVOICE_NOTIIFICATION_Success";
export const SEND_INVOICE_NOTIIFICATION_Failed =
  "SEND_INVOICE_NOTIIFICATION_Failed";
export const SEND_INVOICE_NOTIIFICATION_Loading =
  "SEND_INVOICE_NOTIIFICATION_Loading";
export const SEND_INVOICE_NOTIIFICATION_Reset =
  "SEND_INVOICE_NOTIIFICATION_Reset";

/* export const DELETE_TERMINAL_SUCCESS = "DELETE_TERMINAL_SUCCESS" ; 
export const DELETE_TERMINAL_FAILED ="DELETE_TERMINAL_FAILED" ; 
export const DELETE_TERMINAL_LOADING ="DELETE_TERMINAL_LOADING" ;  */

// payment gateway transactions
export const GET_TRANSACTION_DATA_LOADING = " GET_TRANSACTION_DATA_LOADING";
export const GET_TRANSACTION_DATA_SUCCESS = "GET_TRANSACTION_DATA_SUCCESS";
export const GET_TRANSACTION_DATA_FAILED = "GET_TRANSACTION_DATA_FAILED";
export const GET_TRANSACTION_DATA_REMOVE = "GET_TRANSACTION_DATA_REMOVE";

// apple transactions
export const GET_APPLE_TRANSACTION_DATA_LOADING =
  " GET_APPLE_TRANSACTION_DATA_LOADING";
export const GET_APPLE_TRANSACTION_DATA_SUCCESS =
  "GET_APPLE_TRANSACTION_DATA_SUCCESS";
export const GET_APPLE_TRANSACTION_DATA_FAILED =
  "GET_APPLE_TRANSACTION_DATA_FAILED";
export const GET_APPLE_TRANSACTION_DATA_REMOVE =
  "GET_APPLE_TRANSACTION_DATA_REMOVE";

//payement gateway dashboard data, summary
export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";
export const FETCH_DASHBOARD_DATA_REMOVE = "FETCH_DASHBOARD_DATA_REMOVE";

//payment gateway dashboard , highlights chart
export const FETCH_TRANSACTIONS_HIGHLIGHTS_REQUEST =
  "FETCH_TRANSACTIONS_REQUEST";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_SUCCESS =
  "FETCH_TRANSACTIONS_SUCCESS";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_FAILURE =
  "FETCH_TRANSACTIONS_FAILURE";
export const FETCH_TRANSACTIONS_HIGHLIGHTS_REMOVE = "FETCH_TRANSACTIONS_REMOVE";

//payment gateway dashboard, payement methods, visa, mastercards etc
export const FETCH_PAYEMENT_METHODS_REQUEST = "FETCH_PAYMENT_METHODS_REQUEST";
export const FETCH_PAYEMENT_METHODS_SUCCESS = "FETCH_PAYMENT_METHODS_SUCCESS";
export const FETCH_PAYEMENT_METHODS_FAILURE = "FETCH_PAYMENT_METHODS_FAILURE";
export const FETCH_PAYEMENT_METHODS_REMOVE = "FETCH_PAYMENT_METHODS_REMOVE";

//payment gateway dashboard, geo payment map
export const FETCH_GEO_PAYEMENT_REQUEST = "FETCH_GEO_PAYMENT_REQUEST";
export const FETCH_GEO_PAYEMENT_SUCCESS = "FETCH_GEO_PAYMENT_SUCCESS";
export const FETCH_GEO_PAYEMENT_FAILURE = "FETCH_GEO_PAYMENT_FAILURE";
export const FETCH_GEO_PAYEMENT_REMOVE = "FETCH_GEO_PAYMENT_REMOVE";

//payment gateway chart, bar chart
export const FETCH_PAYEMENT_CHART_REQUEST = "FETCH_PAYMENT_CHART_REQUEST";
export const FETCH_PAYEMENT_CHART_SUCCESS = "FETCH_PAYMENT_CHART_SUCCESS";
export const FETCH_PAYEMENT_CHART_FAILURE = "FETCH_PAYMENT_CHART_FAILURE";
export const FETCH_PAYEMENT_CHART_REMOVE = "FETCH_PAYMENT_CHART_REMOVE";

//apple pay merchant config
export const ADD_APPLEPAY_LOADING = "ADD_APPLEPAY_LOADING";
export const ADD_APPLEPAY_SUCCESS = "ADD_APPLEPAY_SUCCESS";
export const ADD_APPLEPAY_FAILED = "ADD_APPLEPAY_FAILED";

//add card payment merchant config
export const ADD_CARDCONFIG_LOADING = "ADD_CARDCONFIG_LOADING";
export const ADD_CARDCONFIG_SUCCESS = "ADD_CARDCONFIG_SUCCESS";
export const ADD_CARDCONFIG_FAILED = "ADD_CARDCONFIG_FAILED";

//update card payment merchant config
export const PUT_CARDCONFIG_LOADING = "PUT_CARDCONFIG_LOADING";
export const PUT_CARDCONFIG_SUCCESS = "PUT_CARDCONFIG_SUCCESS";
export const PUT_CARDCONFIG_FAILED = "PUT_CARDCONFIG_FAILED";

//update urpay payment merchant config
export const PUT_URPAYCONFIG_LOADING = "PUT_URPAYCONFIG_LOADING";
export const PUT_URPAYCONFIG_SUCCESS = "PUT_URPAYCONFIG_SUCCESS";
export const PUT_URPAYCONFIG_FAILED = "PUT_URPAYCONFIG_FAILED";

//update apple payment merchant config
export const PUT_APPLECONFIG_LOADING = "PUT_APPLECONFIG_LOADING";
export const PUT_APPLECONFIG_SUCCESS = "PUT_APPLECONFIG_SUCCESS";
export const PUT_APPLECONFIG_FAILED = "PUT_APPLECONFIG_FAILED";

//find payment merchant config
export const GET_PAYMENTCONFIG_LOADING = "GET_PAYMENTCONFIG_LOADING";
export const GET_PAYMENTCONFIG_SUCCESS = "GET_PAYMENTCONFIG_SUCCESS";
export const GET_PAYMENTCONFIG_FAILED = "GET_PAYMENTCONFIG_FAILED";
export const GET_PAYMENTCONFIG_REMOVE = "GET_PAYMENTCONFIG_REMOVE";

//find urpay payment merchant config
export const GET_URPAYCONFIG_LOADING = "GET_URPAYCONFIG_LOADING";
export const GET_URPAYCONFIG_SUCCESS = "GET_URPAYCONFIG_SUCCESS";
export const GET_URPAYCONFIG_FAILED = "GET_URPAYCONFIG_FAILED";

//find apple payment merchant config
export const GET_APPLECONFIG_LOADING = "GET_APPLECONFIG_LOADING";
export const GET_APPLECONFIG_SUCCESS = "GET_APPLECONFIG_SUCCESS";
export const GET_APPLECONFIG_FAILED = "GET_APPLECONFIG_FAILED";

//add urpay merchant config
export const ADD_URPAYCONFIG_LOADING = "ADD_URPAYCONFIG_LOADING";
export const ADD_URPAYCONFIG_SUCCESS = "ADD_URPAYCONFIG_SUCCESS";
export const ADD_URPAYCONFIG_FAILED = "ADD_URPAYCONFIG_FAILED";

//MANAFITH
export const ADD_MANAFITH_LOADING = "ADD_MANAFITH_LOADING";
export const ADD_MANAFITH_SUCCESS = "ADD_MANAFITH_SUCCESS";
export const ADD_MANAFITH_FAILED = "ADD_MANAFITH_FAILED";
export const ADD_MANAFITH_REMOVE = "ADD_MANAFITH_REMOVE";

//Tamara
export const ADD_TAMARAH_LOADING = "ADD_TAMARAH_LOADING";
export const ADD_TAMARAH_SUCCESS = "ADD_TAMARAH_SUCCESS";
export const ADD_TAMARAH_FAILED = "ADD_TAMARAH_FAILED";
export const ADD_TAMARAH_REMOVE = "ADD_TAMARAH_REMOVE";
//Tabby
export const ADD_TABBY_LOADING = "ADD_TABBY_LOADING";
export const ADD_TABBY_SUCCESS = "ADD_TABBY_SUCCESS";
export const ADD_TABBY_FAILED = "ADD_TABBY_FAILED";
export const ADD_TABBY_REMOVE = "ADD_TABBY_REMOVE";

//SADAD
export const ADD_SADAD_LOADING = "ADD_SADAD_LOADING";
export const ADD_SADAD_SUCCESS = "ADD_SADAD_SUCCESS";
export const ADD_SADAD_FAILED = "ADD_SADAD_FAILED";
export const ADD_SADAD_REMOVE = "ADD_SADAD_REMOVE";

//ClickToPay
export const ADD_CLICKTOPAY_LOADING = "ADD_CLICKTOPAY_LOADING";
export const ADD_CLICKTOPAY_SUCCESS = "ADD_CLICKTOPAY_SUCCESS";
export const ADD_CLICKTOPAY_FAILED = "ADD_CLICKTOPAY_FAILED";
export const ADD_CLICKTOPAY_REMOVE = "ADD_CLICKTOPAY_REMOVE";

//add merchant onboarding
export const ADD_NEWMERCHANT_LOADING = "ADD_NEWMERCHANT_LOADING";
export const ADD_NEWMERCHANT_SUCCESS = "ADD_NEWMERCHANT_SUCCESS";
export const ADD_NEWMERCHANT_FAILED = "ADD_NEWMERCHANT_FAILED";
export const ADD_NEWMERCHANT_REMOVE = "ADD_NEWMERCHANT_REMOVE";

//
export const GET_ONBOADINGFILES_LOADING = "GET_ONBOADINGFILES_LOADING";
export const GET_ONBOADINGFILES_SUCCESS = "GET_ONBOADINGFILES_SUCCESS";
export const GET_ONBOADINGFILES_FAILED = "GET_ONBOADINGFILES_FAILED";
export const GET_ONBOADINGFILES_REMOVE = "GET_ONBOADINGFILES_REMOVE";

//add new Product
export const ADD_NEWPRODUCT_LOADING = "ADD_NEWPRODUCT_LOADING";
export const ADD_NEWPRODUCT_SUCCESS = "ADD_NEWPRODUCT_SUCCESS";
export const ADD_NEWPRODUCT_FAILED = "ADD_NEWPRODUCT_FAILED";

//get product list
export const GET_PRODUCT_LOADING = "GET_PRODUCT_LOADING";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILED = "GET_PRODUCT_FAILED";

//edit Product
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILED = "EDIT_PRODUCT_FAILED";
export const EDIT_PRODUCT_LOADING = "EDIT_PRODUCT_LOADING";

//delete Product
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILED = "DELETE_PRODUCT_FAILED";
export const DELETE_PRODUCT_LOADING = "DELETE_PRODUCT_LOADING";

//get Product Templates
export const GET_PRODUCT_TEMPLATES_LOADING = "GET_PRODUCT_TEMPLATES_LOADING";
export const GET_PRODUCT_TEMPLATES_SUCCESS = "GET_PRODUCT_TEMPLATES_SUCCESS";
export const GET_PRODUCT_TEMPLATES_FAILED = "GET_PRODUCT_TEMPLATES_FAILED";

//get Invoices by Template
export const GET_INVOICES_BY_TEMPLATE_LOADING = "GET_INVOICES_BY_TEMPLATE_LOADING";
export const GET_INVOICES_BY_TEMPLATE_SUCCESS = "GET_INVOICES_BY_TEMPLATE_SUCCESS";
export const GET_INVOICES_BY_TEMPLATE_FAILED = "GET_INVOICES_BY_TEMPLATE_FAILED";
export const GET_INVOICES_BY_TEMPLATE_RESET = "GET_INVOICES_BY_TEMPLATE_RESET";

//delete Customer
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAILED = "DELETE_CUSTOMER_FAILED";
export const DELETE_CUSTOMER_LOADING = "DELETE_CUSTOMER_LOADING";

//add new Customer
export const ADD_NEWCUSTOMER_LOADING = "ADD_NEWCUSTOMER_LOADING";
export const ADD_NEWCUSTOMER_SUCCESS = "ADD_NEWCUSTOMER_SUCCESS";
export const ADD_NEWCUSTOMER_FAILED = "ADD_NEWCUSTOMER_FAILED";

//get customers list
export const GET_CUSTOMERS_LOADING = "GET_CUSTOMERS_LOADING";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_FAILED = "GET_CUSTOMERS_FAILED";

//get terminals list-filter
export const GET_TERMINALSLIST_LOADING = "GET_TERMINALSLIST_LOADING";
export const GET_TERMINALSLIST_FAILED = "GET_TERMINALSLIST_FAILED";
export const GET_TERMINALSLIST_SUCCESS = "GET_TERMINALSLIST_SUCCESS";

//edit customer
export const EDIT_CUSTOMERS_LOADING = "EDIT_CUSTOMERS_LOADING";
export const EDIT_CUSTOMERS_SUCCESS = "EDIT_CUSTOMERS_SUCCESS";
export const EDIT_CUSTOMERS_FAILED = "EDIT_CUSTOMERS_FAILED";

//delete Merchant
export const DELETE_MERCHANT_SUCCESS = "DELETE_MERCHANT_SUCCESS";
export const DELETE_MERCHANT_FAILED = "DELETE_MERCHANT_FAILED";
export const DELETE_MERCHANT_LOADING = "DELETE_MERCHANT_LOADING";
export const DELETE_MERCHANT_REMOVE = "DELETE_MERCHANT_REMOVE";
export const DELETE_MERCHANT_RESET = "DELETE_MERCHANT_RESET";

//get countries list
export const GET_ALLCOUNTRY_LOADING = "GET_ALLCOUNTRY_LOADING";
export const GET_ALLCOUNTRY_SUCCESS = "GET_ALLCOUNTRY_SUCCESS";
export const GET_ALLCOUNTRY_FAILED = "GET_ALLCOUNTRY_FAILED";

//add countries list
export const ADD_COUNTRY_LOADING = "ADD_COUNTRY_LOADING";
export const ADD_COUNTRY_SUCCESS = "ADD_COUNTRY_SUCCESS";
export const ADD_COUNTRY_FAILED = "ADD_COUNTRY_FAILED";

//delete countries list
export const DELETE_COUNTRY_LOADING = "DELETE_COUNTRY_LOADING";
export const DELETE_COUNTRY_SUCCESS = "DELETE_COUNTRY_SUCCESS";
export const DELETE_COUNTRY_FAILED = "DELETE_COUNTRY_FAILED";

//get countries list
export const GET_CITY_LOADING = "GET_CITYY_LOADING";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_FAILED = "GET_CITY_FAILED";

//edit country
export const EDIT_CITY_LOADING = "EDIT_CITY_LOADING";
export const EDIT_CITY_SUCCESS = "EDIT_CITY_SUCCESS";
export const EDIT_CITY_FAILED = "EDIT_CITY_FAILED";

//add countries list
export const ADD_CITY_LOADING = "ADD_CITY_LOADING";
export const ADD_CITY_SUCCESS = "ADD_CITY_SUCCESS";
export const ADD_CITY_FAILED = "ADD_CITY_FAILED";

//add countries list
export const DELETE_CITY_LOADING = "DELETE_CITY_LOADING";
export const DELETE_CITY_SUCCESS = "DELETE_CITY_SUCCESS";
export const DELETE_CITY_FAILED = "DELETE_CITY_FAILED";

//edit country
export const EDIT_COUNTRY_LOADING = "EDIT_COUNTRY_LOADING";
export const EDIT_COUNTRY_SUCCESS = "EDIT_COUNTRY_SUCCESS";
export const EDIT_COUNTRY_FAILED = "EDIT_COUNTRY_FAILED";

//get countries list
export const GET_ALLCURRENCY_LOADING = "GET_ALLCURRENCY_LOADING";
export const GET_ALLCURRENCY_SUCCESS = "GET_ALLCURRENCY_SUCCESS";
export const GET_ALLCURRENCY_FAILED = "GET_ALLCURRENCY_FAILED";

//add tms
export const ADD_NEWTMS_LOADING = "ADD_NEWTMS_LOADING";
export const ADD_NEWTMS_SUCCESS = "ADD_NEWTMS_SUCCESS";
export const ADD_NEWTMS_FAILED = "ADD_NEWTMS_FAILED";

//get all tms
export const GET_ALLTMS_LOADING = "GET_ALLTMS_LOADING";
export const GET_ALLTMS_SUCCESS = "GET_ALLTMS_SUCCESS";
export const GET_ALLTMS_FAILED = "GET_ALLTMS_FAILED";
export const GET_ALLTMS_REMOVE = "GET_ALLTMS_REMOVE";

export const ADD_BUSINESSCATEGORY_LOADING = "ADD_BUSINESSCATEGORY_LOADING";
export const ADD_BUSINESSCATEGORY_SUCCESS = "ADD_BUSINESSCATEGORY_SUCCESS";
export const ADD_BUSINESSCATEGORY_FAILED = "ADD_BUSINESSCATEGORY_FAILED";

export const UPDATE_BUSINESSCATEGORY_LOADING =
  "UPDATE_BUSINESSCATEGORY_LOADING";
export const UPDATE_BUSINESSCATEGORY_SUCCESS =
  "UPDATE_BUSINESSCATEGORY_SUCCESS";
export const UPDATE_BUSINESSCATEGORY_FAILED = "UPDATE_BUSINESSCATEGORY_FAILED";

export const GET_ALLBUSINESSCATEGORY_LOADING =
  "GET_ALLBUSINESSCATEGORY_LOADING";
export const GET_ALLBUSINESSCATEGORY_SUCCESS =
  "GET_ALLBUSINESSCATEGORY_SUCCESS";
export const GET_ALLBUSINESSCATEGORY_FAILED = "GET_ALLBUSINESSCATEGORY_FAILED";

export const ACTIVATE_BUSINESSCATEGORY_LOADING =
  "ACTIVATE_BUSINESSCATEGORY_LOADING";
export const ACTIVATE_BUSINESSCATEGORY_SUCCESS =
  "ACTIVATE_BUSINESSCATEGORY_SUCCESS";
export const ACTIVATE_BUSINESSCATEGORY_FAILED =
  "ACTIVATE_BUSINESSCATEGORY_FAILED";

export const DEACTIVATE_BUSINESSCATEGORY_LOADING =
  "DEACTIVATE_BUSINESSCATEGORY_LOADING";
export const DEACTIVATE_BUSINESSCATEGORY_SUCCESS =
  "DEACTIVATE_BUSINESSCATEGORY_SUCCESS";
export const DEACTIVATE_BUSINESSCATEGORY_FAILED =
  "DEACTIVATE_BUSINESSCATEGORY_FAILED";

export const TRIGGER_PAYMENTS_LOADING = "TRIGGER_PAYMENTS_LOADING";
export const TRIGGER_PAYMENTS_SUCCESS = "TRIGGER_PAYMENTS_SUCCESS";
export const TRIGGER_PAYMENTS_FAILED = "TRIGGER_PAYMENTS_FAILED";
export const TRIGGER_PAYMENTS_REMOVE = "TRIGGER_PAYMENTS_REMOVE";

export const ACTIVATE_TMS_LOADING = "ACTIVATE_TMS_LOADING";
export const ACTIVATE_TMS_SUCCESS = "ACTIVATE_TMS_SUCCESS";
export const ACTIVATE_TMS_FAILED = "ACTIVATE_TMS_FAILED";

export const DEACTIVATE_TMS_LOADING = "DEACTIVATE_TMS_LOADING";
export const DEACTIVATE_TMS_SUCCESS = "DEACTIVATE_TMS_SUCCESS";
export const DEACTIVATE_TMS_FAILED = "DEACTIVATE_TMS_FAILED";

export const EDIT_CURRENCY_LOADING = "EDIT_CURRENCY_LOADING";
export const EDIT_CURRENCY_SUCCESS = "EDIT_CURRENCY_SUCCESS";
export const EDIT_CURRENCY_FAILED = "EDIT_CURRENCY_FAILED";

export const DELETE_CURRENCY_LOADING = "DELETE_CURRENCY_LOADING";
export const DELETE_CURRENCY_SUCCESS = "DELETE_CURRENCY_SUCCESS";
export const DELETE_CURRENCY_FAILED = "DELETE_CURRENCY_FAILED";

export const GET_ALLRETAILER_LOADING = "GET_ALLRETAILER_LOADING";
export const GET_ALLRETAILER_SUCCESS = "GET_ALLRETAILER_SUCCESS";
export const GET_ALLRETAILER_FAILED = "GET_ALLRETAILER_FAILED";
export const GET_ALLRETAILER_REMOVE = "GET_ALLRETAILER_REMOVE";

export const EDIT_RETAILER_LOADING = "EDIT_RETAILER_LOADING";
export const EDIT_RETAILER_SUCCESS = "EDIT_RETAILER_SUCCESS";
export const EDIT_RETAILER_FAILED = "EDIT_RETAILER_FAILED";

export const ADD_RETAILER_LOADING = "ADD_RETAILER_LOADING";
export const ADD_RETAILER_SUCCESS = "ADD_RETAILER_SUCCESS";
export const ADD_RETAILER_FAILED = "ADD_RETAILER_FAILED";

export const PARTNER_LOADING = "PARTNER_LOADING";
export const PARTNER_SUCCESS = "PARTNER_SUCCESS";
export const PARTNER_FAILED = "PARTNER_FAILED";
export const PARTNER_REMOVE = "PARTNER_REMOVE";

// Recurring Merchant
export const RECURRING_MERCHANT_LOADING = "RECURRING_MERCHANT_LOADING";
export const RECURRING_MERCHANT_SUCCESS = "RECURRING_MERCHANT_SUCCESS";
export const RECURRING_MERCHANT_FAILED = "RECURRING_MERCHANT_FAILED";
export const RECURRING_MERCHANT_REMOVE = "RECURRING_MERCHANT_REMOVE";

export const PARTNER_RECURRING_LOADING = "PARTNER_RECURRING_LOADING";
export const PARTNER_RECURRING_SUCCESS = "PARTNER_RECURRING_SUCCESS";
export const APPEND_PARTNER_RECURRING_SUCCESS = "APPEND_PARTNER_RECURRING_SUCCESS";
export const PARTNER_RECURRING_FAILED = "PARTNER_RECURRING_FAILED";
export const PARTNER_RECURRING_REMOVE = "PARTNER_RECURRING_REMOVE";
export const RESET_PARTNER_RECURRING_LIST = "RESET_PARTNER_RECURRING_LIST";

export const USER_LOADING = "USER_LOADING";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAILED = "USER_FAILED";
export const USER_REMOVE = "USER_REMOVE";

export const GET_PARTNER_LOADING = "GET_PARTNER_LOADING";
export const GET_PARTNER_SUCCESS = "GET_PARTNER_SUCCESS";
export const GET_PARTNER_FAILED = "GET_PARTNER_FAILED";
export const GET_PARTNER_REMOVE = "GET_PARTNER_REMOVE";

export const GET_AUDITLOGS_LOADING = "GET_AUDITLOGS_LOADING";
export const GET_AUDITLOGS_SUCCESS = "GET_AUDITLOGS_SUCCESS";
export const GET_AUDITLOGS_FAILED = "GET_AUDITLOGS_FAILED";

export const GET_ALLPAYMENTGY_LOADING = "GET_ALLPAYMENTGY_LOADING";
export const GET_ALLPAYMENTGY_SUCCESS = "GET_ALLPAYMENTGY_SUCCESS";
export const GET_ALLPAYMENTGY_FAILED = "GET_ALLPAYMENTGY_FAILED";

export const GET_VERSIONDETAILS_LOADING = "GET_VERSIONDETAILS_LOADING";
export const GET_VERSIONDETAILS_SUCCESS = "GET_VERSIONDETAILS_SUCCESS";
export const GET_VERSIONDETAILS_FAILED = "GET_VERSIONDETAILS_FAILED";

export const ADD_NEWVERSION_LOADING = "ADD_NEWVERSIONY_LOADING";
export const ADD_NEWVERSION_SUCCESS = "ADD_NEWVERSION_SUCCESS";
export const ADD_NEWVERSION_FAILED = "ADD_NEWVERSION_FAILED";
export const ADD_NEWVERSION_REMOVE = "ADD_NEWVERSION_REMOVE";

export const GET_PARTNERTHEME_LOADING = "GET_PARTNERTHEME_LOADING";
export const GET_PARTNERTHEME_SUCCESS = "GET_PARTNERTHEME_SUCCESS";
export const GET_PARTNERTHEME_FAILED = "GET_PARTNERTHEME_FAILED";
export const GET_PARTNERTHEME_REMOVE = "GET_PARTNERTHEME_REMOVE";

export const GET_TRX_REQ_LOADING = "GET_TRX_REQ_LOADING";
export const GET_TRX_REQ_SUCCESS = "GET_TRX_REQ_SUCCESS";
export const GET_TRX_REQ_FAILED = "GET_TRX_REQ_FAILED";
export const GET_TRX_REQ_REMOVE = "GET_TRX_REQ_REMOVE";

export const GET_TRX_RES_LOADING = "GET_TRX_RES_LOADING";
export const GET_TRX_RES_SUCCESS = "GET_TRX_RES_SUCCESS";
export const GET_TRX_RES_FAILED = "GET_TRX_RES_FAILED";
export const GET_TRX_RES_REMOVE = "GET_TRX_RES_REMOVE";

export const GET_AMSTHREATS_LOADING = "GET_AMSTHREATS_LOADING";
export const GET_AMSTHREATS_SUCCESS = "GET_AMSTHREATS_SUCCESS";
export const GET_AMSTHREATS_FAILED = "GET_AMSTHREATS_FAILED";
export const GET_AMSTHREATS_REMOVE = "GET_AMSTHREATS_REMOVE";

export const GET_SummaryThreatsFromMerchantControl_LOADING =
  "GET_SummaryThreatsFromMerchantControl_LOADING";
export const GET_SummaryThreatsFromMerchantControl_SUCCESS =
  "GET_SummaryThreatsFromMerchantControl_SUCCESS";
export const GET_SummaryThreatsFromMerchantControl_FAILED =
  "GET_SummaryThreatsFromMerchantControl_FAILED";
export const GET_SummaryThreatsFromMerchantControl_REMOVE =
  "GET_SummaryThreatsFromMerchantControl_REMOVE";

export const GET_Top3DetectionNameFromMerchantControl_LOADING =
  "GET_Top3DetectionNameFromMerchantControl_LOADING";
export const GET_Top3DetectionNameFromMerchantControl_SUCCESS =
  "GET_Top3DetectionNameFromMerchantControl_SUCCESS";
export const GET_Top3DetectionNameFromMerchantControl_FAILED =
  "GET_Top3DetectionNameFromMerchantControl_FAILED";
export const GET_Top3DetectionNameFromMerchantControl_REMOVE =
  "GET_Top3DetectionNameFromMerchantControl_REMOVE";

export const GET_Top5TerminalIdFromMerchantControl_LOADING =
  "GET_Top5TerminalIdFromMerchantControl_LOADING";
export const GET_Top5TerminalIdFromMerchantControl_SUCCESS =
  "GET_Top5TerminalIdFromMerchantControl_SUCCESS";
export const GET_Top5TerminalIdFromMerchantControl_FAILED =
  "GET_Top5TerminalIdFromMerchantControl_FAILED";
export const GET_Top5TerminalIdFromMerchantControl_REMOVE =
  "GET_Top5TerminalIdFromMerchantControl_REMOVE";

export const GET_DataByDateFromMerchantControl_LOADING =
  "GET_DataByDateFromMerchantControl_LOADING";
export const GET_DataByDateFromMerchantControl_SUCCESS =
  "GET_DataByDateFromMerchantControl_SUCCESS";
export const GET_DataByDateFromMerchantControl_FAILED =
  "GET_DataByDateFromMerchantControl_FAILED";
export const GET_DataByDateFromMerchantControl_REMOVE =
  "GET_DataByDateFromMerchantControl_REMOVE";

export const GET_SDKLOGINTOKEN_LOADING = "GET_SDKLOGINTOKEN_LOADING";
export const GET_SDKLOGINTOKEN_SUCCESS = "GET_SDKLOGINTOKEN_SUCCESS";
export const GET_SDKLOGINTOKEN_FAILED = "GET_SDKLOGINTOKEN_FAILED";
export const GET_SDKLOGINTOKEN_REMOVE = "GET_SDKLOGINTOKEN_REMOVE";

export const GET_FEED_LOADING = "GET_FEED_LOADING";
export const GET_FEED_SUCCESS = "GET_FEED_SUCCESS";
export const GET_FEED_FAILED = "GET_FEED_FAILED";
export const GET_FEED_REMOVE = "GET_FEED_REMOVE";

export const ADD_PLAN_LOADING = "ADD_PLAN_LOADING";
export const ADD_PLAN_SUCCESS = "ADD_PLAN_SUCCESS";
export const ADD_PLAN_FAILED = "ADD_PLAN_FAILED";

export const FETCH_SUMMARY_LOADING = "FETCH_SUMMARY_LOADING";
export const FETCH_SUMMARY_SUCCESS = "FETCH_SUMMARY_SUCCESS";
export const FETCH_SUMMARY_FAILED = "FETCH_SUMMARY_FAILED";

// Admin Plans
export const FETCH_ADMIN_PLANS_LOADING = "FETCH_ADMIN_PLANS_LOADING";
export const FETCH_ADMIN_PLANS_SUCCESS = "FETCH_ADMIN_PLANS_SUCCESS";
export const FETCH_ADMIN_PLANS_FAILED = "FETCH_ADMIN_PLANS_FAILED";

// Merchant Recurring Plans (merchant recurring page)
export const FETCH_MERCHANT_RECURRING_PLANS_LOADING = "FETCH_MERCHANT_RECURRING_PLANS_LOADING";
export const FETCH_MERCHANT_RECURRING_PLANS_SUCCESS = "FETCH_MERCHANT_RECURRING_PLANS_SUCCESS";
export const FETCH_MERCHANT_RECURRING_PLANS_FAILED = "FETCH_MERCHANT_RECURRING_PLANS_FAILED";

// Assigned Plans (assigned plans page)
export const FETCH_ASSIGNED_PLANS_LOADING = "FETCH_ASSIGNED_PLANS_LOADING";
export const FETCH_ASSIGNED_PLANS_SUCCESS = "FETCH_ASSIGNED_PLANS_SUCCESS";
export const FETCH_ASSIGNED_PLANS_FAILED = "FETCH_ASSIGNED_PLANS_FAILED";

// Deprecated - kept for backward compatibility
export const FETCH_MERCHANT_PLANS_LOADING = "FETCH_MERCHANT_PLANS_LOADING";
export const FETCH_MERCHANT_PLANS_SUCCESS = "FETCH_MERCHANT_PLANS_SUCCESS";
export const FETCH_MERCHANT_PLANS_FAILED = "FETCH_MERCHANT_PLANS_FAILED";

// Partner Plans
export const FETCH_PARTNER_PLANS_LOADING = "FETCH_PARTNER_PLANS_LOADING";
export const FETCH_PARTNER_PLANS_SUCCESS = "FETCH_PARTNER_PLANS_SUCCESS";
export const FETCH_PARTNER_PLANS_FAILED = "FETCH_PARTNER_PLANS_FAILED";

// Deprecated - kept for backward compatibility (remove after full migration)
export const FETCH_PLANS_LOADING = "FETCH_PLANS_LOADING";
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS";
export const FETCH_PLANS_FAILED = "FETCH_PLANS_FAILED";

export const SAVE_SCHEDULE_PAYMENTS_LOADING = "SAVE_SCHEDULE_PAYMENTS_LOADING";
export const SAVE_SCHEDULE_PAYMENTS_SUCCESS = "SAVE_SCHEDULE_PAYMENTS_SUCCESS";
export const SAVE_SCHEDULE_PAYMENTS_FAILED = "SAVE_SCHEDULE_PAYMENTS_FAILED";

export const TOGGLE_PLANS_LOADING = "TOGGLE_PLANS_LOADING";
export const TOGGLE_PLANS_SUCCESS = "TOGGLE_PLANS_SUCCESS";
export const TOGGLE_PLANS_FAILED = "TOGGLE_PLANS_FAILED";

export const UPDATE_PLAN_LOADING = "UPDATE_PLAN_LOADING";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_FAILED = "UPDATE_PLAN_FAILED";

export const GET_PLAN_BY_ID_LOADING = "GET_PLAN_BY_ID_LOADING";
export const GET_PLAN_BY_ID_SUCCESS = "GET_PLAN_BY_ID_SUCCESS";
export const GET_PLAN_BY_ID_FAILED = "GET_PLAN_BY_ID_FAILED";

export const TOGGLE_PLAN_LOADING = "TOGGLE_PLAN_LOADING";
export const TOGGLE_PLAN_SUCCESS = "TOGGLE_PLAN_SUCCESS";
export const TOGGLE_PLAN_FAILED = "TOGGLE_PLAN_FAILED";

export const DELETE_PLAN_LOADING = "DELETE_PLAN_LOADING";
export const DELETE_PLAN_SUCCESS = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_FAILED = "DELETE_PLAN_FAILED";
export const DELETE_PLAN_RESET = "DELETE_PLAN_RESET";

export const REMOVE_PLANS_LOADING = "REMOVE_PLANS_LOADING";
export const REMOVE_PLANS_SUCCESS = "REMOVE_PLANS_SUCCESS";
export const REMOVE_PLANS_FAILED = "REMOVE_PLANS_FAILED";

export const ASSIGN_PLANS_LOADING = "ASSIGN_PLANS_LOADING";
export const ASSIGN_PLANS_SUCCESS = "ASSIGN_PLANS_SUCCESS";
export const ASSIGN_PLANS_FAILED = "ASSIGN_PLANS_FAILED";

export const FETCH_PLAN_SUMMARY_LOADING = "FETCH_PLAN_SUMMARY_LOADING";
export const FETCH_PLAN_SUMMARY_SUCCESS = "FETCH_PLAN_SUMMARY_SUCCESS";
export const FETCH_PLAN_SUMMARY_FAILED = "FETCH_PLAN_SUMMARY_FAILED";

export const FETCH_PLAN_MERCHANTS_LOADING = "FETCH_PLAN_MERCHANTS_LOADING";
export const FETCH_PLAN_MERCHANTS_SUCCESS = "FETCH_PLAN_MERCHANTS_SUCCESS";
export const FETCH_PLAN_MERCHANTS_FAILED = "FETCH_PLAN_MERCHANTS_FAILED";

export const FETCH_MERCHANTS_LOADING = "FETCH_MERCHANTS_LOADING";
export const FETCH_MERCHANTS_SUCCESS = "FETCH_MERCHANTS_SUCCESS";
export const FETCH_MERCHANTS_FAILED = "FETCH_MERCHANTS_FAILED";

export const SET_INVOICE_SUMMARY = "SET_INVOICE_SUMMARY";
export const CLEAR_INVOICE_SUMMARY = "CLEAR_INVOICE_SUMMARY";

export const FETCH_SCHEDULES_REQUEST = "FETCH_SCHEDULES_REQUEST";
export const FETCH_SCHEDULES_LOADING = "FETCH_SCHEDULES_LOADING";
export const FETCH_SCHEDULES_SUCCESS = "FETCH_SCHEDULES_SUCCESS";
export const FETCH_SCHEDULES_FAILURE = "FETCH_SCHEDULES_FAILURE";

export const FETCH_PLANS_BY_AMOUNT_LOADING = "FETCH_PLANS_BY_AMOUNT_LOADING";
export const FETCH_PLANS_BY_AMOUNT_SUCCESS = "FETCH_PLANS_BY_AMOUNT_SUCCESS";
export const FETCH_PLANS_BY_AMOUNT_FAILED = "FETCH_PLANS_BY_AMOUNT_FAILED";

export const DUPLICATE_PLAN_LOADING = "DUPLICATE_PLAN_LOADING";
export const DUPLICATE_PLAN_SUCCESS = "DUPLICATE_PLAN_SUCCESS";
export const DUPLICATE_PLAN_FAILED = "DUPLICATE_PLAN_FAILED";

export const FETCH_PLAN_TEMPLATES_LOADING = "FETCH_PLAN_TEMPLATES_LOADING";
export const FETCH_PLAN_TEMPLATES_SUCCESS = "FETCH_PLAN_TEMPLATES_SUCCESS";
export const FETCH_PLAN_TEMPLATES_FAILED = "FETCH_PLAN_TEMPLATES_FAILED";

export const SAVE_TERMS_ACCEPTANCE_LOADING = "SAVE_TERMS_ACCEPTANCE_LOADING";
export const SAVE_TERMS_ACCEPTANCE_SUCCESS = "SAVE_TERMS_ACCEPTANCE_SUCCESS";
export const SAVE_TERMS_ACCEPTANCE_FAILED = "SAVE_TERMS_ACCEPTANCE_FAILED";

export const BULK_ACTIONS_LOADING = "BULK_ACTIONS_LOADING";
export const BULK_ACTIONS_SUCCESS = "BULK_ACTIONS_SUCCESS";
export const BULK_ACTIONS_FAILED = "BULK_ACTIONS_FAILED";

export const SEND_PAYMENT_LINK_LOADING = "SEND_PAYMENT_LINK_LOADING";
export const SEND_PAYMENT_LINK_SUCCESS = "SEND_PAYMENT_LINK_SUCCESS";
export const SEND_PAYMENT_LINK_FAILED = "SEND_PAYMENT_LINK_FAILED";

export const SEND_TRANSACTION_RECEIPT_LOADING = "SEND_TRANSACTION_RECEIPT_LOADING";
export const SEND_TRANSACTION_RECEIPT_SUCCESS = "SEND_TRANSACTION_RECEIPT_SUCCESS";
export const SEND_TRANSACTION_RECEIPT_FAILED = "SEND_TRANSACTION_RECEIPT_FAILED";
export const SEND_TRANSACTION_RECEIPT_RESET = "SEND_TRANSACTION_RECEIPT_RESET";

export const SEND_PAYMENT_REMINDER_LOADING = "SEND_PAYMENT_REMINDER_LOADING";
export const SEND_PAYMENT_REMINDER_SUCCESS = "SEND_PAYMENT_REMINDER_SUCCESS";
export const SEND_PAYMENT_REMINDER_FAILED = "SEND_PAYMENT_REMINDER_FAILED";

export const UPDATE_PAYMENT_STATUS_LOADING = "UPDATE_PAYMENT_STATUS_LOADING";
export const UPDATE_PAYMENT_STATUS_SUCCESS = "UPDATE_PAYMENT_STATUS_SUCCESS";
export const UPDATE_PAYMENT_STATUS_FAILED = "UPDATE_PAYMENT_STATUS_FAILED";

export const CANCEL_PAYMENT_SCHEDULE_LOADING = "CANCEL_PAYMENT_SCHEDULE_LOADING";
export const CANCEL_PAYMENT_SCHEDULE_SUCCESS = "CANCEL_PAYMENT_SCHEDULE_SUCCESS";
export const CANCEL_PAYMENT_SCHEDULE_FAILED = "CANCEL_PAYMENT_SCHEDULE_FAILED";

export const REFUND_PAYMENT_SCHEDULE_LOADING = "REFUND_PAYMENT_SCHEDULE_LOADING";
export const REFUND_PAYMENT_SCHEDULE_SUCCESS = "REFUND_PAYMENT_SCHEDULE_SUCCESS";
export const REFUND_PAYMENT_SCHEDULE_FAILED = "REFUND_PAYMENT_SCHEDULE_FAILED";

export const FETCH_SUMMARY_STATUS_LOADING = "FETCH_SUMMARY_STATUS_LOADING";
export const FETCH_SUMMARY_STATUS_SUCCESS = "FETCH_SUMMARY_STATUS_SUCCESS";
export const FETCH_SUMMARY_STATUS_FAILED = "FETCH_SUMMARY_STATUS_FAILED";

export const FETCH_CONFIGURATIONS_LOADING = "FETCH_CONFIGURATIONS_LOADING";
export const FETCH_CONFIGURATIONS_SUCCESS = "FETCH_CONFIGURATIONS_SUCCESS";
export const FETCH_CONFIGURATIONS_FAILED = "FETCH_CONFIGURATIONS_FAILED";

export const DOWNLOAD_INVOICE_LOADING = "DOWNLOAD_INVOICE_LOADING";
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS";
export const DOWNLOAD_INVOICE_FAILED = "DOWNLOAD_INVOICE_FAILED";

export const FETCH_TERMS_LOADING = "FETCH_TERMS_LOADING";
export const FETCH_TERMS_SUCCESS = "FETCH_TERMS_SUCCESS";
export const FETCH_TERMS_FAILED = "FETCH_TERMS_FAILED";

export const DOWNLOAD_TERMS_PDF_REQUEST = "DOWNLOAD_TERMS_PDF_REQUEST";
export const DOWNLOAD_TERMS_PDF_SUCCESS = "DOWNLOAD_TERMS_PDF_SUCCESS";
export const DOWNLOAD_TERMS_PDF_FAILURE = "DOWNLOAD_TERMS_PDF_FAILURE";
export const DOWNLOAD_TERMS_PDF_LOADING = "DOWNLOAD_TERMS_PDF_LOADING";

export const FETCH_TERMS_ACCEPTANCE_LOADING = "FETCH_TERMS_ACCEPTANCE_LOADING";
export const FETCH_TERMS_ACCEPTANCE_SUCCESS = "FETCH_TERMS_ACCEPTANCE_SUCCESS";
export const FETCH_TERMS_ACCEPTANCE_FAILED = "FETCH_TERMS_ACCEPTANCE_FAILED";

export const GET_PAYMENT_RESPONSE_LOADING = "GET_PAYMENT_RESPONSE_LOADING";
export const GET_PAYMENT_RESPONSE_SUCCESS = "GET_PAYMENT_RESPONSE_SUCCESS";
export const GET_PAYMENT_RESPONSE_FAILED = "GET_PAYMENT_RESPONSE_FAILED";

export const UPDATE_INSTALLMENT_STATUS_LOADING =
  "UPDATE_INSTALLMENT_STATUS_LOADING";
export const UPDATE_INSTALLMENT_STATUS_SUCCESS =
  "UPDATE_INSTALLMENT_STATUS_SUCCESS";
export const UPDATE_INSTALLMENT_STATUS_FAILED =
  "UPDATE_INSTALLMENT_STATUS_FAILED";

export const FETCH_RECURRING_PAYMENT_CARDHOLDER_LOADING =
  "FETCH_RECURRING_PAYMENT_CARDHOLDER_LOADING";
export const FETCH_RECURRING_PAYMENT_CARDHOLDER_SUCCESS =
  "FETCH_RECURRING_PAYMENT_CARDHOLDER_SUCCESS";
export const FETCH_RECURRING_PAYMENT_CARDHOLDER_FAILED =
  "FETCH_RECURRING_PAYMENT_CARDHOLDER_FAILED";

export const UPDATE_RECURRING_PAYMENT_CARDHOLDER_LOADING =
  "UPDATE_RECURRING_PAYMENT_CARDHOLDER_LOADING";
export const UPDATE_RECURRING_PAYMENT_CARDHOLDER_SUCCESS =
  "UPDATE_RECURRING_PAYMENT_CARDHOLDER_SUCCESS";
export const UPDATE_RECURRING_PAYMENT_CARDHOLDER_FAILED =
  "UPDATE_RECURRING_PAYMENT_CARDHOLDER_FAILED";

export const DOWNLOAD_TRANSACTIONS_EXCEL_LOADING =
  "DOWNLOAD_TRANSACTIONS_EXCEL_LOADING";
export const DOWNLOAD_TRANSACTIONS_EXCEL_SUCCESS =
  "DOWNLOAD_TRANSACTIONS_EXCEL_SUCCESS";
export const DOWNLOAD_TRANSACTIONS_EXCEL_FAILED =
  "DOWNLOAD_TRANSACTIONS_EXCEL_FAILED";

export const GET_HOSTS_BY_CONTACT_LOADING = "GET_HOSTS_BY_CONTACT_LOADING";
export const GET_HOSTS_BY_CONTACT_SUCCESS = "GET_HOSTS_BY_CONTACT_SUCCESS";
export const GET_HOSTS_BY_CONTACT_FAILED = "GET_HOSTS_BY_CONTACT_FAILED";

export const ADDING_THEME_CONFIG_LOADING = "ADDING_THEME_CONFIG_LOADING";
export const ADDING_THEME_CONFIG_SUCCESS = "ADDING_THEME_CONFIG_SUCCESS";
export const ADDING_THEME_CONFIG_FAILED = "ADDING_THEME_CONFIG_FAILED";

export const GET_ALL_PARTNERS_LOADING = "GET_ALL_PARTNERS_LOADING";
export const GET_ALL_PARTNERS_SUCCESS = "GET_ALL_PARTNERS_SUCCESS";
export const GET_ALL_PARTNERS_FAILED = "GET_ALL_PARTNERS_FAILED";

export const GET_ALL_PARTNER_HOSTS_LOADING = "GET_ALL_PARTNER_HOSTS_LOADING";
export const GET_ALL_PARTNER_HOSTS_SUCCESS = "GET_ALL_PARTNER_HOSTS_SUCCESS";
export const GET_ALL_PARTNER_HOSTS_FAILED = "GET_ALL_PARTNER_HOSTS_FAILED";

export const GET_PARTNER_HOST_DETAILS_LOADING =
  "GET_PARTNER_HOST_DETAILS_LOADING";
export const GET_PARTNER_HOST_DETAILS_SUCCESS =
  "GET_PARTNER_HOST_DETAILS_SUCCESS";
export const GET_PARTNER_HOST_DETAILS_FAILED =
  "GET_PARTNER_HOST_DETAILS_FAILED";

export const ADD_PARTNER_HOST_LOADING = "ADD_PARTNER_HOST_LOADING";
export const ADD_PARTNER_HOST_SUCCESS = "ADD_PARTNER_HOST_SUCCESS";
export const ADD_PARTNER_HOST_FAILED = "ADD_PARTNER_HOST_FAILED";

export const UPDATE_PARTNER_HOST_LOADING = "UPDATE_PARTNER_HOST_LOADING";
export const UPDATE_PARTNER_HOST_SUCCESS = "UPDATE_PARTNER_HOST_SUCCESS";
export const UPDATE_PARTNER_HOST_FAILED = "UPDATE_PARTNER_HOST_FAILED";

export const UPDATE_THEME_CONFIG_LOADING = "UPDATE_THEME_CONFIG_LOADING";
export const UPDATE_THEME_CONFIG_SUCCESS = "UPDATE_THEME_CONFIG_SUCCESS";
export const UPDATE_THEME_CONFIG_FAILED = "UPDATE_THEME_CONFIG_FAILED";


export const SET_CUSTOMER_SUPPORT_CREDENTIALS_LOADING = "SET_CUSTOMER_SUPPORT_CREDENTIALS_LOADING";
export const SET_CUSTOMER_SUPPORT_CREDENTIALS_SUCCESS = "SET_CUSTOMER_SUPPORT_CREDENTIALS_SUCCESS";
export const SET_CUSTOMER_SUPPORT_CREDENTIALS_FAILED = "SET_CUSTOMER_SUPPORT_CREDENTIALS_FAILED";
export const SET_CUSTOMER_SUPPORT_CREDENTIALS_RESET = "SET_CUSTOMER_SUPPORT_CREDENTIALS_RESET";
